//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/RoutingCommon.js";
import "../no/Object.js";
import "../no/Routing.js";
import "../no/Session.js";
let d=[[],[[["designRuleMethodId"],"RemoveDesignRule",{},1,0],[["reason"],"RemoveAllDesignRulesForReason",{},1,0],[[],"RemoveAllDesignRules",{},0,0],[["reason","nRegisteredDesignRules","registeredDesignRuleIds"],"GetDesignRulesRegisteredForReason",{},1,0],[["reason","nViolations"],"GetViolationsForReason",{R_:{violations:"Routing.DesignRuleViolation[]"}},1,0],[["designRuleName","nViolations"],"GetViolationsOfRule",{R_:{violations:"Routing.DesignRuleViolation[]"}},1,0],[["designRuleName","reason","shortDescription","longDescription","objects"],"CreateViolationForReason",{R_:{violation:"Routing.DesignRuleViolation"}},5,0],[["reason","nxObject"],"DeleteViolationsOnObjectForReason",{},2,0],[["designRuleName","nxObject"],"DeleteViolationsOfRuleOnObject",{},2,0],[[],"RemoveAllPlugins",{},0,0],[[],"RemoveRSDApplicationEnterPlugin",{},0,0],[[],"RemoveRSDApplicationExitPlugin",{},0,0],[[],"RemoveCablewayXmlFileNamePlugin",{},0,0],[[],"RemoveCablewayUniqueNodeNamePlugin",{},0,0],[[],"RemoveCablewayUniqueSegmentNamePlugin",{},0,0],[[],"RemoveCablewayDeviceIdentifierPlugin",{},0,0],[[],"RemoveCablewayPreExportPlugin",{},0,0],[[],"RemoveCablewayPostExportPlugin",{},0,0],[[],"RemoveCablewayAreaNamePlugin",{},0,0],[[],"RemoveWiringComponentNamePlugin",{},0,0],[[],"RemoveSpoolNamePlugin",{},0,0],[[],"RemoveSpoolAssemblyNamePlugin",{},0,0]],[]];
SPLM.RoutingCommon.CustomManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.RoutingCommon.CustomManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.RoutingCommon.CustomManager.Application = Object.freeze({
    "Electrical" : "Electrical", "Mechanical" : "Mechanical"});

export default SPLM;